<div *ngIf="isLoading === false; else deliveriesLoading" class="ps-flex-container-col"
     style="gap: 12px">
  <mat-card *ngFor="let delivery of deliveries" [class]="getBackground(delivery)">

    <mat-card-header>
      <mat-icon mat-card-avatar>schedule</mat-icon>
      <mat-card-title>{{delivery.PLANNED_DATE | date}}
      </mat-card-title>
    </mat-card-header>

    <div class="ps-grid-3-col">
      <div class="ps-flex-container-col">
        <div>
          <h4
            *ngIf="delivery.PBO_DELIVERY_NAME; else openDelivery">
            <span style="padding-right: 8px">{{delivery.PBOSUBTYPENAME}}</span>
            <img class="mat-icon" *ngIf="delivery.FREIGABE_ICON"
                 [src]="icons[delivery.FREIGABE_ICON]"
                 [alt]="delivery.FREIGABE_ICON" style="padding-right: 8px">
            <span>{{delivery.PBO_DELIVERY_NAME}}</span>
          </h4>
          <ng-template #openDelivery>
            <h4>{{'orders.deliveries.plannedDelivery.openDelivery' | translate}} ({{delivery.PBOSUBTYPENAME}})</h4>
          </ng-template>
        </div>
        <div>{{'orders.deliveries.plannedDelivery.ownDeliveryNote' | translate}}: {{delivery.DELIVERYNOTE_NR}}</div>
        <div *ngIf="delivery.INCIDENT">{{'orders.deliveries.plannedDelivery.incident' | translate}}
          : {{delivery.INCIDENT}}</div>
      </div>

      <div class="ps-flex-container-col">
        <h4 style="align-self: center">Status</h4>
        <div class="status-container ps-grid-3-col">
          <div>{{'orders.deliveries.plannedDelivery.planned' | translate}}</div>
          <div>{{'orders.deliveries.plannedDelivery.delivered' | translate}}</div>
          <div>{{'orders.deliveries.plannedDelivery.checked' | translate}}</div>

          <div>{{delivery.PLANNED_COUNT}}</div>
          <div>{{delivery.DELIVERYNOTE_COUNT}} <span
            *ngIf="delivery.DELIVERYNOTE_COUNT > delivery.CONFIRMED && !checkOpen(delivery)"
            style="color: red; font-weight: bold">({{delivery.CONFIRMED - delivery.DELIVERYNOTE_COUNT}})</span>
          </div>
          <div *ngIf="checkDelivered(delivery)">{{delivery.CONFIRMED}}</div>
        </div>
      </div>

      <div class="ps-flex-container-col">
        <h4>{{'orders.deliveries.plannedDelivery.deliveryComment' | translate}}</h4>
        {{delivery.DELIVERYNOTE_COMMENT}}
      </div>

    </div>

    <mat-card-actions align="end">
      <button *ngIf="hasIndexAi() && (!delivery.PBO_DELIVERY_ID || (checkCanceled(delivery)))"
              mat-button
              matTooltip="{{'orders.deliveries.plannedDelivery.createDeliveryNote' | translate}}"
              color="primary"
              (click)="createDeliveryNote(delivery)">
        <mat-icon matBadge="+" matBadgeColor="accent">local_shipping</mat-icon>
      </button>
      <button mat-button color="primary" matTooltip="{{'orders.deliveries.plannedDelivery.edit' | translate}}"
              *ngIf="!delivery.PBO_DELIVERY_ID && !checkCanceled(delivery)"
              (click)="openEditPlannedDeliveryBottomsheet(delivery)">
        <mat-icon>edit</mat-icon>
      </button>
      <button mat-button color="primary" matTooltip="{{'orders.deliveries.plannedDelivery.delete' | translate}}"
              *ngIf="!delivery.PBO_DELIVERY_ID || checkCanceled(delivery)" (click)="deleteDelivery(delivery)">
        <mat-icon>delete forever</mat-icon>
      </button>
      <button mat-button color="primary"
              *ngIf="delivery.PBO_DELIVERY_ID && !checkCanceled(delivery) && !checkDelivered(delivery)"
              matTooltip="{{'orders.deliveries.plannedDelivery.cancel' | translate}}"
              (click)="cancelDelivery(delivery.PBO_DELIVERY_ID)">
        <mat-icon matBadge="-" matBadgeColor="accent">
          local_shipping
        </mat-icon>
      </button>
      <button mat-button color="primary" (click)="downloadDeliveryNote(delivery)"
              *ngIf="delivery.PBO_DELIVERY_ID && !checkCanceled(delivery)"
              matTooltip="{{'orders.deliveries.plannedDelivery.downloadConsignment' | translate}}">
        <mat-icon>picture_as_pdf</mat-icon>
      </button>
    </mat-card-actions>

  </mat-card>

  <mat-card *ngIf="deliveries.length === 0">
    {{'orders.deliveries.plannedDelivery.noPlannedDeliveries' | translate}}
  </mat-card>
</div>
<ng-template #deliveriesLoading>
  {{'orders.deliveries.plannedDelivery.loadingPlannedDeliveries' | translate}}...
</ng-template>
